var Backbone, SupportHelpWizardController, SupportOrderListViewTemplate, SupportOrderView, SupportPurchaseDateTemplate, SupportV1OrderListView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderView = require('./order_list_element_view');

SupportHelpWizardController = require('../../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportOrderListViewTemplate = require('../../../order_list_view.html.mustache');

SupportPurchaseDateTemplate = require('../../../purchase_date.html.mustache');

SupportV1OrderListView = (function(superClass) {
  extend(SupportV1OrderListView, superClass);

  function SupportV1OrderListView() {
    return SupportV1OrderListView.__super__.constructor.apply(this, arguments);
  }

  SupportV1OrderListView.prototype.id = 'orderContent';

  SupportV1OrderListView.prototype.events = {
    "click #purchasedDateSortOrders": "sortAndRender",
    "click #merchantNameSortOrders": "sortAndRender",
    "click .orderTableRow": "clickingItemsTableRow",
    "click #orderNotListed": "orderNotListed",
    "click .ordersRowError": "handleErrorLinkClick"
  };

  SupportV1OrderListView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportOrderListViewTemplate;
    this.purchaseDatetemplate = SupportPurchaseDateTemplate;
    this.currentChosenItemId = 0;
    this.currentCheckedRadioBtnSel = 0;
    this.tableId = '#ordersTable';
    this.itemView = SupportOrderView;
    this.currentOrdersFilter = options.currentOrdersFilter;
    return this.setSortParams();
  };

  SupportV1OrderListView.prototype.setSortParams = function() {
    this.sortParams = {
      sort_attribute: this.currentOrdersFilter.getSortAttribute(),
      sort_order: this.currentOrdersFilter.getSortOrder()
    };
    if (this.sortParams.sort_attribute === 'purchased_at') {
      this.currentSortElementId = 'purchasedDateSortOrders';
    } else {
      this.currentSortElementId = 'merchantNameSortOrders';
    }
    if (this.sortParams.sort_order === 'descending') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV1OrderListView.prototype.resetSortParams = function() {
    if (this.isDescSortOrder) {
      this.sortParams.sort_order = 'descending';
    } else {
      this.sortParams.sort_order = 'ascending';
    }
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.sortParams.sort_attribute = 'purchased_at';
    } else {
      return this.sortParams.sort_attribute = 'merchant_name';
    }
  };

  SupportV1OrderListView.prototype.setCurrentFilter = function() {
    var filter;
    this.resetSortParams();
    filter = Groupon.Support.OrdersCollection.getFilterInstance(this.sortParams);
    filter.iterator.resetIterator();
    this.currentOrdersFilter = Groupon.Support.currentOrdersFilter = filter;
    return filter;
  };

  SupportV1OrderListView.prototype.render = function() {
    var _scrollLoad, hash;
    this.currentOrdersFilter.iterator.resetIterator();
    hash = {
      enableMerchantNameSortOrders: this.currentSortElementId === 'purchasedDateSortOrders'
    };
    this.$el.html(toHtml(this.template, hash, this.I18nScope));
    _scrollLoad = (function(_this) {
      return function() {
        var $div;
        $div = $("#ordersTablewrapper", _this.$el);
        if (($div[0].scrollHeight - $div.scrollTop()) <= ($div.height() + 40)) {
          if (!_this.currentOrdersFilter.iterator.hasNext()) {
            return;
          }
          return _this.renderOrders();
        }
      };
    })(this);
    $("#ordersTablewrapper", this.$el).scroll(_.debounce(_scrollLoad, 100));
    this.renderOrders();
    return this.delegateEvents();
  };

  SupportV1OrderListView.prototype.renderPurchaseDateView = function(dateStr) {
    var hash;
    hash = {
      purchasedAt: dateStr
    };
    return toHtml(this.purchaseDatetemplate, hash, this.I18nScope);
  };

  SupportV1OrderListView.prototype.renderItems = function(orders) {
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.renderOrdersGroupedByPurchaseDate(orders);
    } else {
      return this.renderOrdersByMerchantName(orders);
    }
  };

  SupportV1OrderListView.prototype.renderOrdersByMerchantName = function(items) {
    var current, i, itemsTable, len, results;
    if (!((items != null ? items.length : void 0) > 0)) {
      return;
    }
    itemsTable = this.$el.find(this.tableId);
    results = [];
    for (i = 0, len = items.length; i < len; i++) {
      current = items[i];
      if (current) {
        results.push(this.renderSingleItem(current, itemsTable));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  SupportV1OrderListView.prototype.renderOrdersGroupedByPurchaseDate = function(orders) {
    var i, itemView, lastRow, len, orderData, ordersTable, results;
    if (!((orders != null ? orders.length : void 0) > 0)) {
      return;
    }
    ordersTable = $(this.el).find(this.tableId);
    results = [];
    for (i = 0, len = orders.length; i < len; i++) {
      orderData = orders[i];
      lastRow = $("tr.orderTableRow[dateStr=\"" + orderData.purchasedAtshortDatetimeStr + "\"]:last-child", this.$el);
      if (lastRow.length > 0) {
        itemView = new this.itemView;
        itemView.renderSingleItem(orderData);
        results.push(lastRow.after(itemView.$el));
      } else {
        ordersTable.append(this.renderPurchaseDateView(orderData.purchasedAtshortDatetimeStr));
        results.push(this.renderSingleItem(orderData, ordersTable));
      }
    }
    return results;
  };

  SupportV1OrderListView.prototype.renderSingleItem = function(orderData, $container) {
    var itemView;
    itemView = new this.itemView;
    itemView.renderSingleItem(orderData);
    return $container.append(itemView.$el);
  };

  SupportV1OrderListView.prototype.sortAndRender = function(e) {
    var currentjQuerySel;
    currentjQuerySel = $(e.currentTarget);
    if (this.currentSortElementId === currentjQuerySel.attr('id')) {
      this.isDescSortOrder = !this.isDescSortOrder;
    } else {
      this.removeDisableClassFromPreviousSortLink();
      this.currentSortElementId = currentjQuerySel.attr('id');
      this.addDisableClassToSortLink(this.currentSortElementId);
      this.setDefaultSortOrder();
    }
    this.setCurrentFilter();
    $(this.el).find(this.tableId).empty();
    return this.renderOrders();
  };

  SupportV1OrderListView.prototype.setDefaultSortOrder = function() {
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV1OrderListView.prototype.removeDisableClassFromPreviousSortLink = function() {
    var ele;
    ele = $('#' + this.currentSortElementId);
    return ele.removeClass("disabledLink");
  };

  SupportV1OrderListView.prototype.addDisableClassToSortLink = function(selectorId) {
    var ele;
    ele = $('#' + selectorId);
    return ele.addClass("disabledLink");
  };

  SupportV1OrderListView.prototype.orderNotListed = function() {
    GIG.Modal.close();
    Groupon.Support.ORDER_NOT_LISTED = true;
    Groupon.Support.NOT_ORDER_RELATED = false;
    SupportHelpWizardController.changeCurrentOrder(null);
    Backbone.history.navigate('#select-issue', {
      trigger: true
    });
    return false;
  };

  SupportV1OrderListView.prototype.finishChoosingItem = function(e) {
    var item;
    GIG.Modal.close();
    if ((this.currentChosenItemId != null) && String(Groupon.Support.currentOrder.id) !== String(this.currentChosenItemId)) {
      item = Groupon.Support.OrdersCollection.findOrderById(this.currentChosenItemId);
      if (item != null) {
        SupportHelpWizardController.stepOne(item);
      }
    }
    return false;
  };

  SupportV1OrderListView.prototype.clickingItemsTableRow = function(e) {
    var ele, radioBtn;
    ele = $(e.currentTarget);
    radioBtn = ele.find('input');
    if (this.currentCheckedRadioBtnSel !== 0) {
      this.currentCheckedRadioBtnSel.prop('checked', false);
    }
    this.currentCheckedRadioBtnSel = radioBtn;
    radioBtn.prop('checked', true);
    this.currentChosenItemId = ele.attr('key');
    this.finishChoosingItem();
    return false;
  };

  SupportV1OrderListView.prototype.handleErrorLinkClick = function() {
    this.currentOrdersFilter.iterator.resetState();
    return this.renderOrders();
  };

  SupportV1OrderListView.prototype.renderOrders = function() {
    var errCb, successCb;
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    this.removeOrdersFetchError();
    this.renderSpinner();
    successCb = (function(_this) {
      return function(orders) {
        _this.removeSpinner();
        if ((orders != null ? orders.length : void 0) > 0) {
          _this.renderItems(orders);
          return _this.checkIfMinimumOrdersAreShown();
        } else {
          return _this.renderOrders();
        }
      };
    })(this);
    errCb = (function(_this) {
      return function() {
        _this.removeSpinner();
        return _this.renderOrdersFetchError();
      };
    })(this);
    return this.currentOrdersFilter.iterator.next(successCb, errCb);
  };

  SupportV1OrderListView.prototype.checkIfMinimumOrdersAreShown = function() {
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    if (this.currentOrdersFilter.iterator.getNumberOfOrdersFetched() < this.currentOrdersFilter.iterator.getNumberOfItemPerPage()) {
      return this.renderOrders();
    }
  };

  SupportV1OrderListView.prototype.renderOrdersFetchError = function() {
    var ordersTable;
    this.removeOrdersFetchError();
    ordersTable = $(this.el).find(this.tableId);
    return ordersTable.append(this.errorHtml());
  };

  SupportV1OrderListView.prototype.errorHtml = function() {
    var $ordersRowError;
    $ordersRowError = $('.template-table tr.ordersRowErrorSample', this.$el).clone();
    $ordersRowError.removeClass('ordersRowErrorSample').addClass('ordersRowError');
    return $ordersRowError;
  };

  SupportV1OrderListView.prototype.removeOrdersFetchError = function() {
    return $('.ordersRowError', this.$el).remove();
  };

  SupportV1OrderListView.prototype.renderSpinner = function() {
    var ordersTable;
    this.removeSpinner();
    ordersTable = $(this.el).find(this.tableId);
    return ordersTable.append(this.spinnerHtml());
  };

  SupportV1OrderListView.prototype.spinnerHtml = function() {
    var $div, $ordersRowSpinner;
    $div = $("<div></div>");
    showLoading($div, "50px");
    $ordersRowSpinner = $('.template-table tr.ordersRowSpinnerSample', this.$el).clone();
    $('.content', $ordersRowSpinner).html($div.html());
    $ordersRowSpinner.removeClass('ordersRowSpinnerSample').addClass('ordersRowSpinner');
    return $ordersRowSpinner;
  };

  SupportV1OrderListView.prototype.removeSpinner = function() {
    return $('.ordersRowSpinner', this.$el).remove();
  };

  return SupportV1OrderListView;

})(Backbone.View);

module.exports = SupportV1OrderListView;

//# sourceMappingURL=data:application/json;base64,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
